/**
 * Uruguayan peso.
 */
export var UYU = {
  code: 'UYU',
  base: 10,
  exponent: 2
};